const InformationIcon = ({ className }: { className?: string }) => {
    return (
        <svg className={className} height="16px" viewBox="0 0 20 20" width="16px">
            <circle
                cx="9.75"
                cy="9.75"
                r="9"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <rect x="9" y="8" width="1.5" height="7" fill="currentColor" />
            <rect x="9" y="5" width="1.5" height="1.5" fill="currentColor" />
        </svg>
    )
}

export default InformationIcon
